module.exports = __webpack_public_path__ + "img/integration.10f911ce.png";